import React,{useContext} from 'react'
import {makeStyles} from "@material-ui/core/styles";
import {store} from "../Freight"
import Skeleton from '@material-ui/lab/Skeleton';
import Alert from "@material-ui/lab/Alert"
import Phone from "./Phone"
import axios from "../../../../../../../api/axios"

const useStyles = makeStyles((theme) => ({
    root:{
        display:'grid',
        gridTemplateColumns:'1fr',
        gridGap:theme.spacing(1)
    },
    phones:{
        display:'flex',
        flexFlow:'row wrap',
        width:'100%',
        '& > div:not(:last-child)':{
            marginRight:theme.spacing(1)
        },
        '& > div':{
            marginBottom:theme.spacing(1)
        }
    },
    noRecord:{
        margin:theme.spacing(2,0),
        width:'100%', 
    }
}))

const ListPhones = () => {
    const classes = useStyles();
    const {state:{phones},refresh,showMessage,showError} = useContext(store);

    const handleDeletePhone = async(phoneId)=>{
        try {
            const {data} = await axios.delete(`/api/v1/admin/users/phones/${phoneId}`);
            if(data?.ok) showMessage(data?.messages);
            refresh('fetchCustomerPhones');
        } catch (error) {
            showError(error);
        }
    }
  return (
    <div className={classes.root}>
        <div className={classes.phones}>
            {
                phones?<>
                    {phones?.length?<div className={classes.phones}>
                        {phones?.map(phone=>(<Phone deletePhone={handleDeletePhone} phone={phone} key={phone._id} />))}
                    </div>:<div className={classes.noRecord}><Alert severity="info">شماره تلفن و یا موبایل اشخاص مرتبط با این صاحب بار را وارد کنید.</Alert></div>}
                </>:<Skeleton variant="text" height={56} width="100%" animation="pulse" />
            }
        </div>
    </div>
  )
}

export default ListPhones
